var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowDownIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 6,
    viewBox: "0 0 10 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.40445 0.812731C9.23856 0.653711 9.01416 0.564453 8.78025 0.564453C8.54635 0.564453 8.32195 0.653711 8.15606 0.812731L4.97754 3.83518L1.84329 0.812731C1.6774 0.653711 1.453 0.564453 1.2191 0.564453C0.985191 0.564453 0.760789 0.653711 0.594902 0.812731C0.511917 0.892103 0.446049 0.986534 0.4011 1.09058C0.35615 1.19462 0.333008 1.30622 0.333008 1.41893C0.333008 1.53164 0.35615 1.64324 0.4011 1.74728C0.446049 1.85132 0.511917 1.94575 0.594902 2.02513L4.34892 5.64523C4.43123 5.72526 4.52915 5.78878 4.63704 5.83212C4.74493 5.87547 4.86066 5.89779 4.97754 5.89779C5.09442 5.89779 5.21014 5.87547 5.31804 5.83212C5.42593 5.78878 5.52385 5.72526 5.60616 5.64523L9.40445 2.02513C9.48743 1.94575 9.5533 1.85132 9.59825 1.74728C9.6432 1.64324 9.66634 1.53164 9.66634 1.41893C9.66634 1.30622 9.6432 1.19462 9.59825 1.09058C9.5533 0.986534 9.48743 0.892103 9.40445 0.812731Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownIcon);
export default __webpack_public_path__ + "static/media/arrow-down-icon.425ed4fe0d757f422381a953699f22ce.svg";
export { ForwardRef as ReactComponent };